<app-icon
  [ngClass]="{
    valid: isValid,
    invalid: !isValid,
  }"
  [iconName]="'asterisk'"
  width="20px"
  height="20px"
></app-icon>
